module.exports = __webpack_public_path__ + "img/113006.01836070.png";